import { render, staticRenderFns } from "./GatherIssueStatus.vue?vue&type=template&id=63f1453c"
import script from "./GatherIssueStatus.vue?vue&type=script&lang=js"
export * from "./GatherIssueStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports